/* Nav "Find my ring size" modal (2026-09-16) and the product-page sizer modal (#rsModal) tweaks. Moved out of
   snippets/nav-ring-sizer.liquid by Round 1 decision #23 (javascript-10, Wade 2026-10-13) so it is cached instead of
   re-sent in every page; the snippet keeps the modal markup and styles and loads this file with defer. */
  (function () {
    var modal = document.getElementById('feNavSizer');
    if (!modal) return;
    var dialog = modal.querySelector('.fns-dialog');
    var lastFocus = null;

    var track = function (name, params) {
      try {
        if (typeof window.gtag !== 'function') return;
        var id = 'G-CNG4X1659M', dl = window.dataLayer || [];
        for (var i = 0; i < dl.length; i++) {
          if (dl[i] && dl[i][0] === 'config' && /^G-/.test(dl[i][1] || '')) { id = dl[i][1]; break; }
        }
        var p = { send_to: id };
        if (params) for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) p[k] = params[k];
        window.gtag('event', name, p);
      } catch (e) {}
    };

    var show = function (trigger) {
      lastFocus = trigger || document.activeElement;
      var sb = document.getElementById('sidebar-menu');
      if (sb && sb.hasAttribute('open')) {
        try { typeof sb.hide === 'function' ? sb.hide() : sb.removeAttribute('open'); } catch (e) { sb.removeAttribute('open'); }
      }
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      document.body.classList.add('fns-modal-open');
      try { dialog.focus({ preventScroll: true }); } catch (e) { dialog.focus(); }
      track('nav_ring_sizer_open');
    };
    var hide = function () {
      modal.hidden = true;
      document.body.style.overflow = '';
      document.body.classList.remove('fns-modal-open');
      /* Return focus to the trigger; if it is hidden again (mobile menu closed), to the menu button. */
      var back = lastFocus && lastFocus.offsetParent !== null ? lastFocus : document.querySelector('[aria-controls="sidebar-menu"]');
      if (back && typeof back.focus === 'function') {
        try { back.focus({ preventScroll: true }); } catch (e) {}
      }
      lastFocus = null;
    };

    /* Header links to the ring-sizer page open the modal. Capture phase so nothing else
       navigates first; modified clicks (new tab) and the footer / in-content links pass through. */
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || a.closest('#feNavSizer')) return;
      /* The mobile menu drawer (header-sidebar) is moved out of x-header to <body> while open. */
      if (!a.closest('x-header, header-sidebar, #sidebar-menu, .header, #shopify-section-header, [id^="shopify-section-"][id$="__header"]')) return;
      var href = a.getAttribute('href') || '';
      if (!/(^|\/)pages\/ring-sizer\/?(\?|#|$)/.test(href)) return;
      e.preventDefault();
      show(a);
    }, true);

    modal.querySelectorAll('[data-fns-close]').forEach(function (el) { el.addEventListener('click', hide); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) hide(); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(dialog.querySelectorAll('button:not([disabled]), a[href]'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    modal.querySelectorAll('[data-fns-print]').forEach(function (el) { el.addEventListener('click', function () { track('nav_ring_sizer_print'); }); });
    var guide = modal.querySelector('[data-fns-guide]');
    guide && guide.addEventListener('click', function () { track('nav_ring_sizer_guide'); });

    /* Same add flow as the product-page modal: add via cart/add.js, close, cart drawer opens. */
    var addBtn = modal.querySelector('[data-fns-add]');
    addBtn && addBtn.addEventListener('click', function () {
      if (addBtn.getAttribute('aria-busy') === 'true') return;
      var vid = addBtn.getAttribute('data-fns-add');
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var fallback = function () { window.location.href = root + 'cart/add?id=' + vid + '&quantity=1'; };
      if (!window.fetch || !window.FormData) { fallback(); return; }
      addBtn.setAttribute('aria-busy', 'true');
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      var fd = new FormData();
      fd.set('id', vid); fd.set('quantity', '1');
      fd.set('sections', sections.join(',')); fd.set('sections_url', root + 'variants/' + vid);
      fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'add failed'); return j; }); })
        .then(function (added) {
          track('nav_ring_sizer_mail');
          var st = (window.themeVariables && window.themeVariables.settings) || {};
          if (st.cartType === 'page' || st.pageType === 'cart') { window.location.href = root + 'cart'; return; }
          return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            cart.sections = added.sections || {};
            hide();
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
          });
        })
        .catch(fallback)
        .then(function () { addBtn.removeAttribute('aria-busy'); });
    });

    /* ---- Product-page sizer modal tweaks (runs after mens-ring.js / couples-set.js) ---- */
    var tweakPdp = function () {
      var m = document.getElementById('rsModal');
      if (!m) return true;
      if (m.getAttribute('data-fns-tweaked')) return true;
      var tabs = m.querySelector('.rs-tabs');
      var tab = function (k) { return m.querySelector('.rs-tab[data-tab="' + k + '"]'); };
      var panel = function (k) { return m.querySelector('.rs-panel[data-panel="' + k + '"]'); };
      var mailTab = tab('mail'), mailPanel = panel('mail');
      if (!tabs || !mailTab || !mailPanel) return false;
      ['mail', 'print', 'dial', 'chart'].forEach(function (k) { var t = tab(k); t && tabs.appendChild(t); });
      m.querySelectorAll('.rs-tab').forEach(function (t) { t.classList.remove('active'); });
      m.querySelectorAll('.rs-panel').forEach(function (p) { p.classList.remove('active'); });
      mailTab.classList.add('active');
      mailPanel.classList.add('active');
      var box = mailPanel.firstElementChild;
      if (box) {
        box.style.background = '#F4F5F9';
        var ps = box.querySelectorAll('p');
        if (ps[0]) ps[0].style.color = '#0D1B3E';
        if (ps[1]) {
          ps[1].style.color = '#1C1C1C';
          ps[1].textContent = "We'll mail you a free plastic sizer with $5 credit toward your ring. US only. To keep it free it goes by regular letter mail without tracking, so allow 3 to 7 days.";
        }
        var b = box.querySelector('[data-rs-mail-add]');
        if (b) {
          b.style.background = '#0D1B3E';
          b.style.fontWeight = '600';
          b.style.minHeight = '44px';
          if (!box.querySelector('.rs-mail-fine')) {
            var fine = document.createElement('p');
            fine.className = 'rs-mail-fine';
            fine.style.cssText = 'margin:10px 0 0;font-size:12px;line-height:1.4;color:#2F3E75;text-align:center;';
            fine.textContent = 'A sizer also ships with every ring order.';
            b.insertAdjacentElement('afterend', fine);
          }
        }
      }
      m.setAttribute('data-fns-tweaked', '1');
      return true;
    };
    var tries = 0;
    var tick = function () { if (tweakPdp()) return; if (++tries < 60) setTimeout(tick, 150); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
    window.addEventListener('load', tick);
  })();
